import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoginPage from './components/LoginPage';
import Layout from '@/common/Layout';
import { GetProfiles } from './redux/slice';
import NewsTicker from '../NewsTicker';
import { Helmet } from 'react-helmet';
import { initGA, pageview } from '../../utilities/gtag'; // Adjust path if needed
// import CookieConsent from 'react-cookie-consent';
import CookieConsentBanner from './components/CookieConsentBanner'; // Adjust path if needed

const Login = () => {
  const userLang = navigator.language.startsWith('hi') ? 'hi' : 'en';
  const { peofile_list } = useSelector((state) => state.getprofiles);
  const dispatch = useDispatch();
  // console.log('process.env', process.env?.REACT_APP_RAZORPAY_KEY_ID);
  // console.log('getprofiles', peofile_list);
  const [isStayLoggedInChecked, setIsStayLoggedInChecked] = useState(0);

  useEffect(() => {
    getProfilesList();
  }, []);

  // Load GA only if consent is already given (on reload or revisit)
  useEffect(() => {
    if (localStorage.getItem('eliteMatrimonyConsent') === 'true') {
      initGA();
      pageview(window.location.pathname);
    } else {
      initGA(); // Initialize GA once on mount
      pageview(window.location.pathname); // Track this pageview
    }
  }, []);

  const getProfilesList = () => {
    dispatch(GetProfiles());
  };

  return (
    <>
      <Helmet>
        <title>
          Welcome to Elite Samskruti Matrimony - Find your perfect life partner
        </title>
        <meta
          name="description"
          content="Discover your ideal life partner with Elite Samskruti Matrimony. Powered by AI-driven matchmaking, we help you find compatible matches with accuracy and trust in a secure environment."
        />
        <meta
          name="keywords"
          content="welcome, elite matrimony, matchmaking, Indian marriage"
        />
        <link rel="canonical" href="https://elite.lexyslabs.com/welcome" />

        {/* ✅ Add this robots meta tag here */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Elite Samskruti Matrimony | Welcome Page"
        />
        <meta
          property="og:description"
          content="Find your perfect match through India’s most trusted matchmaking platform."
        />
        <meta
          property="og:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
        <meta property="og:url" content="https://elite.lexyslabs.com/welcome" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elite Samskruti Matrimony" />
        <meta
          name="twitter:description"
          content="Where elite families find their perfect match."
        />
        <meta
          name="twitter:image"
          content="https://elite.lexyslabs.com/preview.jpg"
        />
      </Helmet>

      {/* ✅ Cookie Consent Banner */}
      {/* <CookieConsent
        location="bottom"
        cookieName="eliteMatrimonyConsent"
        style={{ background: '#2B373B', zIndex: 9999 }}
        buttonStyle={{ background: '#f60', color: '#fff', fontSize: '13px' }}
        declineButtonStyle={{
          background: '#999',
          color: '#fff',
          fontSize: '13px'
        }}
        buttonText="Accept All"
        enableDeclineButton
        declineButtonText="Decline"
        expires={365}
        onAccept={() => {
          localStorage.setItem('eliteMatrimonyConsent', 'true');
          initGA();
          pageview(window.location.pathname);
        }}
        onDecline={() => {
          localStorage.setItem('eliteMatrimonyConsent', 'false');
        }}
      >
        We use cookies to enhance your experience. By clicking “Accept All,” you
        agree to the use of Analytics cookies. Essential cookies are always
        active.
      </CookieConsent> */}
      {/* ✅ End Cookie Consent */}
      <CookieConsentBanner lang={userLang} />
      <Layout sider={true} hideHeader={true}>
        <LoginPage
          sider={true}
          isStayLoggedInChecked={isStayLoggedInChecked}
          setIsStayLoggedInChecked={setIsStayLoggedInChecked}
          get_profiles={peofile_list}
          NewsTicker={NewsTicker}
        />
      </Layout>
    </>
  );
};

export default Login;
